export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebarParentItem.vue?vue&type=template&id=495108db&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/sidebarParentItem.vue?vue&type=template&id=495108db&
// module id = 337
// module chunks = 30